<span *ngIf="currency">{{
  currencyQuantity
    | currency : currency.uniqSymbol.grapheme : "symbol" : getFractionSize()
}}</span>
